import {Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter} from '@angular/core';
import {LanguageType} from '../shared/types';

const TITLE_HEBREW = 'השמורה הסיננטרופית מציגה';
const TITLE_ENGLISH = 'Synanthrope Preserve Presents';

@Component({
  selector: 'app-welcome-page',
  templateUrl: './welcome-page.component.html',
  styleUrls: ['./welcome-page.component.scss']
})
export class WelcomePageComponent implements OnInit, OnChanges {
  /** Language to use in the welcome page. */
  @Input() language: LanguageType = 'hebrew';

  @Output() enterEvent = new EventEmitter<void>();

  title = TITLE_HEBREW;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['language']) {
      this.title = this.language === 'hebrew' ? TITLE_HEBREW : TITLE_ENGLISH;
    }
  }

  onEnterClick(): void {
    this.enterEvent.emit();
  }

}
